import { render } from "./FailureScreen.vue?vue&type=template&id=7c102f08&scoped=true&ts=true"
import script from "./FailureScreen.vue?vue&type=script&lang=ts"
export * from "./FailureScreen.vue?vue&type=script&lang=ts"

import "./FailureScreen.vue?vue&type=style&index=0&id=7c102f08&lang=scss&scoped=true"

import exportComponent from "/home/ishii_tat_wsl/ghq/github.com/whi-product/ams-bot/company-oauth-success-screen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c102f08"]])

export default __exports__